import { useNavigate, useLocation } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

/**
 * BackButton — bottone "Indietro" discreto riusabile su pagine pubbliche.
 *
 * Comportamento (Fase 7.6):
 *  - Se esiste una pagina precedente nella history INTERNA (React Router
 *    `location.key !== "default"`), usa `navigate(-1)` per rispettare il
 *    percorso dell'utente.
 *  - Altrimenti fallback a `navigate(fallback)` (default `/`).
 *  - Nessun back se l'utente è arrivato in deep-link diretto (evita di
 *    "uscire" dalla webapp verso siti esterni).
 *
 * Stile: freccia + "Indietro", tono muted, no bordo. Coerente col back di
 * /mappa.
 */
export default function BackButton({ fallback = "/", className = "", testid = "back-btn", label = "Indietro" }) {
    const navigate = useNavigate();
    const location = useLocation();
    const onClick = () => {
        // React Router assegna una `key` unica quando naviga con push.
        // La prima entry ha key === "default" → siamo appena arrivati (deep-link).
        if (location.key && location.key !== "default") {
            navigate(-1);
        } else {
            navigate(fallback);
        }
    };
    return (
        <button
            onClick={onClick}
            data-testid={testid}
            className={`inline-flex items-center gap-1.5 text-sm text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))] transition-colors ${className}`}
            aria-label={label}
        >
            <ChevronLeft className="w-4 h-4" strokeWidth={1.5} />
            <span>{label}</span>
        </button>
    );
}
